export default {
	title: 'Szenarien',
	subtitle:
		'Listen Sie alle möglichen Szenarien auf, die Sie bewerten werden',
	no_description: 'Kein Szenario',

	context_worse: 'Negativ',
	context_best: 'Positiv',

	tabs: {
		list: 'Liste',
		details: 'Details',
		visualization: 'Visualisierung',
		alt_title: 'Synthese'
	}
};
